var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.292892 24.2929C-0.0976315 24.6834 -0.0976315 25.3166 0.292892 25.7071L6.65685 32.0711C7.04738 32.4616 7.68054 32.4616 8.07107 32.0711C8.46159 31.6805 8.46159 31.0474 8.07107 30.6569L2.41421 25L8.07107 19.3431C8.46159 18.9526 8.46159 18.3195 8.07107 17.9289C7.68054 17.5384 7.04738 17.5384 6.65685 17.9289L0.292892 24.2929ZM26 24L1 24V26L26 26V24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBack);
export default __webpack_public_path__ + "static/media/Go-Back.e322483b15d34157b0471eb53d52e025.svg";
export { ForwardRef as ReactComponent };